class PrintHide {
  init(){
      // Initial search state elements
      var chat = document.querySelector('.sc-1w3tvxe-0');
      var accesible = document.querySelector('.needsclick');
      var logo = document.querySelector('.mon-logo-container');
      var recaptcha = document.querySelector('.rc-anchor');

      setTimeout(function() {
         if(chat){ chat.classList.add('print:hidden'); }
          if(accesible){ accesible.classList.add('print:hidden'); }
          if(logo){ logo.classList.add('print:hidden'); }
          if(recaptcha){ recaptcha.classList.add('print:hidden'); }
          console.log("DomLoaded print");
      }, 2000); // Delay of 2 seconds

  }
}

export {PrintHide};
